import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],
      sessionId: null,

      // Initialize session ID
      initSession: () => {
        const existingSessionId = get()?.sessionId;
        if (!existingSessionId) {
          const newSessionId = `session_${Date.now()}_${Math.random()?.toString(36)?.substr(2, 9)}`;
          set({ sessionId: newSessionId });
        }
      },

      // Add item to cart
      addItem: (item) => {
        const items = get()?.items;
        const existingItem = items?.find(
          (i) => i?.id === item?.id && i?.type === item?.type
        );

        if (existingItem) {
          // Update quantity for existing item
          set({
            items: items?.map((i) =>
              i?.id === item?.id && i?.type === item?.type
                ? { ...i, quantity: i?.quantity + (item?.quantity || 1) }
                : i
            ),
          });
        } else {
          // Add new item
          set({ items: [...items, { ...item, quantity: item?.quantity || 1 }] });
        }
      },

      // Remove item from cart
      removeItem: (itemId, itemType) => {
        set({
          items: get()?.items?.filter(
            (i) => !(i?.id === itemId && i?.type === itemType)
          ),
        });
      },

      // Update item quantity
      updateQuantity: (itemId, itemType, quantity) => {
        if (quantity <= 0) {
          get()?.removeItem(itemId, itemType);
          return;
        }

        set({
          items: get()?.items?.map((i) =>
            i?.id === itemId && i?.type === itemType
              ? { ...i, quantity }
              : i
          ),
        });
      },

      // Clear cart
      clearCart: () => {
        set({ items: [] });
      },

      // Get cart total
      getTotal: () => {
        return get()?.items?.reduce(
          (total, item) => total + (item?.price || 0) * (item?.quantity || 1),
          0
        );
      },

      // Get cart item count
      getItemCount: () => {
        return get()?.items?.reduce(
          (count, item) => count + (item?.quantity || 1),
          0
        );
      },
    }),
    {
      name: 'up-midia-cart-storage',
      getStorage: () => localStorage,
    }
  )
);

export default useCartStore;